<template>
  <v-content app>
    <v-container fluid>
      <v-layout>
        <v-flex sm12>
          <v-breadcrumbs class="pb-1" icons divider=">">
            <v-breadcrumbs-item>
              <div class="text-uppercase">HOME</div>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item>
              <div class="text-uppercase">{{ $route.params.workspace_name }}</div>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item>
              WORKSPACE MANAGEMENT
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
      </v-layout>
      <v-card class="v-card---style">

        <h2>Manage Workspace - {{ $route.params.workspace_name }}</h2>
        <!-- <h3 class="mb-4 uppercase"><strong>{{ $route.params.workspace_name }}</strong></h3> -->

        <!-- <h3 class="mb-4">Workspace Management</h3> -->
        <section class="pb-5">
          <v-layout row wrap>
            <v-flex xs12>
              <!-- <ul class="tabs-wrapper-2 flex-it reset-list">
                 <li v-for="tab in user_tabs" @click="selectedComponent = tab.component"
                     :class="{'active-tab': selectedComponent === tab.component}">{{ tab.name }}
                 </li>
               </ul> -->

              <!-- <keep-alive>
                <component
                  :is="selectedComponent"></component>
              </keep-alive> -->
              <WorkspaceUsers></WorkspaceUsers>
            </v-flex>
          </v-layout>
        </section>
      </v-card>
    </v-container>
  </v-content>
</template>

<style lang="scss">

  .v-card---style {
    padding: 15px 30px 30px 30px;
  }

  .v-toolbar__content > :first-child.v-btn--icon, .v-toolbar__extension > :first-child.v-btn--icon {
    margin-left: 15px !important;
  }

  .v-breadcrumbs__item {
    color: gray;
    font-size: 12px;
  }

  .container {
    padding: 15px 24px 24px 24px !important;
  }

  .v-breadcrumbs {
    padding: 0 !important;
    margin-bottom: 10px !important;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .no-outline {
    outline: 0;
  }

  .edit-button {
    background: #00c8536b;
    color: white !important;
    border-radius: 2.5px;
    margin: 10px 10px;
  }

  .edit-button:focus {
    outline: 0;
  }

  .editing-name--style {
    padding-top: 20px;
  }

  .editing-name--style > .v-input__control > .v-input__slot > .v-text-field__slot > input {
    color: #0000009c !important;
    font-size: 37px !important;
    padding-bottom: 14px;
  }

  .toast-top-right {
    top: 70px !important;
    right: 23px !important;
  }

  td {
    padding: 15px 0;
  }

  .list--dense .list__tile:not(.list__tile--avatar) {
    height: 50px !important;
  }

  .countries-card--min-height {
    min-height: 305px;
  }

  .flex-it {
    display: flex;
  }

  .tabs-wrapper-2 {
    background: white;
  }

  .tabs-wrapper-2 > li {
    color: #8E8E8F;
    text-align: center;
    margin-right: 20px;
    font-size: 16px;
    cursor: pointer;
  }

  .tabs-wrapper-2 > .active-tab {
    color: #0033A0 !important;
    font-weight: bold;
  }

  .tabs-wrapper-2 > .active-tab::after {
    content: "";
    display: block;
    border-bottom: 2px solid #0033A0 !important;
    position: relative;
    top: 5px;
  }

  .reset-list {
    padding-left: 0;
    list-style-type: none;
  }

  .chart-card {
    padding: 20px;
    background: white;
    margin-bottom: 20px;
  }

  .map-card {
    padding: 20px;
    background: white;
    margin-bottom: 20px;
    height: 308px;
    overflow: hidden;
    position: relative;
  }

  .countries--max-height {
    max-height: 260px;
    overflow-y: scroll;
  }

  .region {
    cursor: pointer;
    font-size: 16px;
    color: #4D4F5C;
    margin-right: 35px;
  }

  .tabs__item--active {
    color: #06B085;
  }

  .list__tile__title {
    color: gray !important;
  }

  .theme--light.application .text--primary {
    color: #7ECEAA !important;
  }

  .edit-account__subtitle {
    color: rgba(0, 0, 0, 0.6);
    font-size: 17px;
  }

  .user-name__title {
    color: #0000009c;
    font-size: 37px;
    font-family: 'Source Sans Pro', 'Helvetica Neue', Arial, sans-serif;
  }
</style>

<script>
  import {axiosInstance} from '../axios-auth'
  import WorkspaceUsers from "../components/workspace/WorkspaceUsers";
  import WorkspaceSettings from "../components/workspace/WorkspaceSettings";

  export default {
    name: "WorkspaceManagement",
    components: {
      WorkspaceUsers,
      WorkspaceSettings
    },
    data() {
      return {
        selectedComponent: 'WorkspaceUsers',
        user_tabs: [
          {name: "Manage Users", component: "WorkspaceUsers", id: 1},
          // {name: "Settings", component: "WorkspaceSettings", id: 2}
        ],
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 6 || 'Min 6 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          }
        }
      }
    },
    methods: {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/WorkspaceManagement.vue